import Icon from '@components/common/Icon';
import { DATA_BASE_URL } from '@lib/constants';

const stats = [
  {
    id: 1,
    value: '3+',
    label: 'Years',
    description: 'Experience in varsity badminton',
    icon: (
      <svg className="w-8 h-8" fill="currentColor" viewBox="0 0 20 20">
        <path
          fillRule="evenodd"
          d="M6 2a1 1 0 00-1 1v1H4a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2V6a2 2 0 00-2-2h-1V3a1 1 0 10-2 0v1H7V3a1 1 0 00-1-1zm0 5a1 1 0 000 2h8a1 1 0 100-2H6z"
          clipRule="evenodd"
        />
      </svg>
    ),
  },
  {
    id: 2,
    value: '3+',
    label: 'International Tournaments',
    description: 'Major competitions participated',
    icon: (
      <svg className="w-8 h-8" fill="currentColor" viewBox="0 0 20 20">
        <path d="M9 2a1 1 0 000 2h2a1 1 0 100-2H9z" />
        <path
          fillRule="evenodd"
          d="M4 5a2 2 0 012-2 3 3 0 003 3h2a3 3 0 003-3 2 2 0 012 2v11a2 2 0 01-2 2H6a2 2 0 01-2-2V5zm9.707 5.707a1 1 0 00-1.414-1.414L9 12.586l-1.293-1.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
          clipRule="evenodd"
        />
      </svg>
    ),
  },
  {
    id: 3,
    value: 'IASAS',
    label: 'International Level',
    description: 'Competed at IASAS tournament',
    icon: (
      <svg className="w-8 h-8" fill="currentColor" viewBox="0 0 20 20">
        <path
          fillRule="evenodd"
          d="M12 1.586l-4 4v12.828l4-4V1.586zM3.707 3.293A1 1 0 002 4v10a1 1 0 00.293.707L6 18.414V5.586L3.707 3.293zM17.707 5.293L14 1.586v12.828l2.293 2.293A1 1 0 0018 16V6a1 1 0 00-.293-.707z"
          clipRule="evenodd"
        />
      </svg>
    ),
  },
  {
    id: 4,
    value: 'ISM',
    label: 'Team Pride, Sportsmanship Award and Most Improved Player Award',
    description: 'Representing ISM in Local and International Tournaments',
    icon: (
      <svg className="w-8 h-8" fill="currentColor" viewBox="0 0 20 20">
        <path d="M13 6a3 3 0 11-6 0 3 3 0 016 0zM18 8a2 2 0 11-4 0 2 2 0 014 0zM14 15a4 4 0 00-8 0v3h8v-3zM6 8a2 2 0 11-4 0 2 2 0 014 0zM16 18v-3a5.972 5.972 0 00-.75-2.906A3.005 3.005 0 0119 15v3h-3zM4.75 12.094A5.973 5.973 0 004 15v3H1v-3a3 3 0 013.75-2.906z" />
      </svg>
    ),
  },
];

const StatsSection = () => {
  return (
    <section className="py-16 sm:py-20 px-4 sm:px-6 lg:px-8" style={{ backgroundColor: 'var(--color-body-bg)' }}>
      <div className="container mx-auto max-w-7xl">
        {/* Section Header */}
        <div className="text-center mb-12 sm:mb-16 space-y-4">
          <div className="flex items-center justify-center gap-2 sm:gap-3 mb-4">
            <Icon name="badminton" size="lg" className="sm:hidden" style={{ color: 'var(--color-accent-6)' }} />
            <Icon name="badminton" size="xl" className="hidden sm:block" style={{ color: 'var(--color-accent-6)' }} />
            <h2
              className="text-3xl sm:text-4xl md:text-5xl font-heading font-bold tracking-tight"
              style={{ color: 'var(--color-heading)' }}
            >
              Season Statistics
            </h2>
          </div>
          <p
            className="text-base sm:text-lg max-w-3xl mx-auto"
            style={{ color: 'var(--color-subtle)' }}
          >
            Key highlights from the badminton journey with ISM
          </p>
        </div>

        {/* Stats Grid - Mobile: horizontal scroll, Desktop: grid */}
        <div className="lg:grid lg:grid-cols-4 lg:gap-8 flex lg:flex-none overflow-x-auto gap-6 pb-6 snap-x snap-mandatory scrollbar-hide -mx-4 px-4 sm:-mx-6 sm:px-6 lg:-mx-0 lg:px-0">
          {stats.map((stat) => (
            <div
              key={stat.id}
              className="group flex-shrink-0 w-[75vw] sm:w-[60vw] lg:w-auto snap-start p-6 sm:p-8 rounded-2xl shadow-card transition-all duration-300 hover:shadow-card-hover text-center"
              style={{
                backgroundColor: 'var(--color-card-bg)',
                borderColor: 'var(--color-card-border)',
                borderWidth: '1px',
                borderStyle: 'solid',
              }}
            >
              {/* Icon */}
              <div className="flex justify-center mb-3 sm:mb-4">
                <div
                  className="inline-flex items-center justify-center w-12 h-12 sm:w-16 sm:h-16 rounded-xl group-hover:scale-110 transition-transform duration-300"
                  style={{
                    backgroundColor: 'var(--color-accent-2)',
                    color: 'var(--color-accent-7)',
                  }}
                >
                  {stat.icon}
                </div>
              </div>

              {/* Value */}
              <div
                className="text-4xl sm:text-5xl font-bold mb-2"
                style={{ color: 'var(--color-accent-6)' }}
              >
                {stat.value}
              </div>

              {/* Label */}
              <h3
                className="text-lg sm:text-xl font-semibold mb-2"
                style={{ color: 'var(--color-heading)' }}
              >
                {stat.label}
              </h3>

              {/* Description */}
              <p
                className="text-xs sm:text-sm"
                style={{ color: 'var(--color-muted)' }}
              >
                {stat.description}
              </p>
            </div>
          ))}
        </div>

        {/* Mobile scroll hint */}
        <div className="lg:hidden text-center mt-6">
          <p className="text-sm" style={{ color: 'var(--color-muted)' }}>
            Swipe to see more statistics
          </p>
        </div>

        {/* Video Section */}
        <div className="mt-12 sm:mt-16 space-y-6 sm:space-y-8">
          <div className="text-center space-y-3 sm:space-y-4">
            <h3
              className="text-2xl sm:text-3xl font-bold"
              style={{ color: 'var(--color-heading)' }}
            >
              Tournament Highlights
            </h3>
            <p
              className="text-base sm:text-lg"
              style={{ color: 'var(--color-subtle)' }}
            >
              Watch highlights from Malaysia Tournament 2024
            </p>
          </div>

          {/* Video Player */}
          <div
            className="max-w-5xl mx-auto rounded-2xl overflow-hidden shadow-card-hover"
            style={{
              borderColor: 'var(--color-accent-4)',
              borderWidth: '2px',
              borderStyle: 'solid',
            }}
          >
            <video
              controls
              className="w-full aspect-video"
              poster={`${DATA_BASE_URL}/data/badminton/photos/BADMINTON MALAYSIA 24.jpg`}
            >
              <source
                src={`${DATA_BASE_URL}/data/badminton/videos/BADMINTON MALAYSIA 24 SRIHAAN.MOV`}
                type="video/mp4"
              />
              Your browser does not support the video tag.
            </video>
          </div>
        </div>
      </div>
    </section>
  );
};

export default StatsSection;
